module.exports = __webpack_public_path__ + "img/moralis.1961bbf8.png";